import { render, staticRenderFns } from "./RdtGerenciar.vue?vue&type=template&id=4dd10256&scoped=true&"
import script from "./RdtGerenciar.vue?vue&type=script&lang=js&"
export * from "./RdtGerenciar.vue?vue&type=script&lang=js&"
import style0 from "./RdtGerenciar.vue?vue&type=style&index=0&id=4dd10256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd10256",
  null
  
)

export default component.exports